import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map, shareReplay, switchMap } from "rxjs/operators";

import { DokumentService } from "../shared/dokument.service";
import { DokumentListeViewModel } from "./dokument-liste.view-model";

@Injectable({ providedIn: "root" })
export class DokumentListeSandbox {
    constructor(private readonly service: DokumentService) {}

    public hentViewModel(): Observable<DokumentListeViewModel> {
        return this.service.hentUmbracoIndstillinger().pipe(
            switchMap((indstillinger) => {
                // returnerer 1000 år hvis antalAar ikke er sat, da default værdi fra Umbraco er 0
                indstillinger.antalAar === 0 || !indstillinger.antalAar ? (indstillinger.antalAar = 1000) : indstillinger.antalAar;
                return this.service.hentDokumenter(indstillinger.antalAar).pipe(
                    map((dokumenter) => ({
                        ...indstillinger,
                        dokumenter
                    }))
                );
            }),
            shareReplay(1)
        );
    }
}
